<div class="card">
    <ngw-tab [items]="items"></ngw-tab>
</div>